import React, { Fragment, useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import {
  MainWrapper,
  LogoWrapper,
  LinkWrapper,
  AuthWrapper,
  AuthIcon,
  UserAvatarImg,
  ArrowIcon,
  LogoImg,
  H1,
  IconLink,
  IconImg,
  IconText,
  HorizontalDivider,
  AvatarTooltipWrapper,
  MobileMainWrapper,
  BurgerBlock,
  BurgerImg,
  MobileDrawer,
  ExpansionSummaryText,
} from './NavWrappers';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actions/allActionList';

import { willHideDefaultNav } from '../../utils/helpers/checkPaths';
import { getAvatarImageURL } from '../../utils/reusables/avatar';
import { setLanguage } from '../../store/actions/indexActions';
import Popper from '../Popper';
import CustomizedMenuItem from '../MenuItem';
import CustomizedButton from '../Buttons/CustomizedButton';
import MuiAlert from '@material-ui/lab/Alert';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import LanguageFooter from './LanguageFooter';
import Snackbar from '@material-ui/core/Snackbar';
import MenuList from '@material-ui/core/MenuList';
import IRLogo from '../../assets/logo/intereact-logo.svg';
import BurgerMenu from '../../assets/icons/hamburger-menu.svg';
import HomeIcon from '../../assets/icons/home.svg';
import HomeActiveIcon from '../../assets/icons/home-active.svg';
import EducatorIcon from '../../assets/icons/educator.svg';
import EducatorActiveIcon from '../../assets/icons/educator-active.svg';
import ClassroomIcon from '../../assets/icons/classroom.svg';
import ClassroomActiveIcon from '../../assets/icons/classroom-active.svg';
import AvatarIcon from '../../assets/icons/avatar-nav.svg';
import DownArrowIcon from '../../assets/icons/down-arrow.svg';
import ProfileMenuIcon from '../../assets/icons/profile-menu.svg';
import ProfileEditIcon from '../../assets/icons/edit-user-menu.svg';
import MyClassroomsIcon from '../../assets/icons/classrooms-menu.svg';
import CreateClassroomMenu from '../../assets/icons/create-classroom-menu.svg';
import SettingsMenuIcon from '../../assets/icons/settings-menu.svg';
import LogoutMenuIcon from '../../assets/icons/logout-menu.svg';
import Italian from '../../assets/images/countries/it.svg';
import English from '../../assets/images/countries/en.svg';
// import Korean from '../../assets/images/countries/kr.svg';
// import Japanese from '../../assets/images/countries/jp.svg';
// import French from '../../assets/images/countries/fr.svg';
// import Filipino from '../../assets/images/countries/tl.svg';

const Alert = (props) => {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
};

const Index = ({
  history,
  location,
  userData,
  userAvatar,
  lang,
  onSetLanguage,
  onSetLoginModalState,
  onUnsetLoginModalState,
  signInStarted,
  signInError,
  signUpStarted,
  signUpError,
  justSignedUp,
  logout,
}) => {
  /* Profile Menu List */
  const [open, setOpen] = useState(false);
  const [openDesktop, setOpenDesktop] = useState(false);
  const [openMobile, setOpenMobile] = useState(false);
  const anchorRef = useRef(null);
  const mobileAnchorRef = useRef(null);

  /* Language Menu List */
  const [openLang, setOpenLang] = useState(false);
  const langAnchorRef = useRef(null);

  /* SideDrawer */
  const [openDrawer, setOpenDrawer] = useState(false);

  const showNav = String(!willHideDefaultNav(location.pathname));

  const handleToggle = () => {
    setOpenDesktop((prevOpen) => !prevOpen);
  };

  const handleMobileToggle = () => {
    setOpenMobile((prevOpen) => !prevOpen);
  };

  const handleLangToggle = (close = false) => {
    if (close) setOpenLang(false);
    else setOpenLang((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpenDesktop(false);
  };

  const handleMobileClose = (event) => {
    if (mobileAnchorRef.current && mobileAnchorRef.current.contains(event.target)) {
      return;
    }

    setOpenMobile(false);
  };

  const handleLangClose = (event) => {
    if (langAnchorRef.current && langAnchorRef.current.contains(event.target)) {
      return;
    }

    setOpenLang(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  function handleMobileListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpenMobile(false);
    }
  }

  function handleLangListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpenLang(false);
    }
  }

  const onLogout = () => {
    handleToggle();
    logout();
  };

  const closeLangMenuThenSetLanguage = (langKey) => {
    handleLangToggle(true);
    onSetLanguage(langKey);
  };

  const toggleDrawer = (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setOpenDrawer(!openDrawer);
  };

  useEffect(() => {
    if (signUpStarted) {
      setOpen(true);
    } else if (signUpError) {
      onSetLoginModalState();
      setOpen(false);
    } else {
      setOpen(false);
    }
  }, [onSetLoginModalState, signUpError, signUpStarted]);

  useEffect(() => {
    if (signInStarted) {
      setOpen(true);
    } else if (signInError) {
      onSetLoginModalState();
      setOpen(false);
    } else {
      setOpen(false);
    }
  }, [onSetLoginModalState, signInError, signInStarted]);

  const homeActiveComponent =
    location.pathname === '/' ? (
      <Fragment>
        <IconImg src={HomeActiveIcon} alt='home-icon' />
        <IconText active>
          {' '}
          <FormattedMessage id='nav.home' />{' '}
        </IconText>
      </Fragment>
    ) : (
      <Fragment>
        <IconImg src={HomeIcon} alt='home-icon' />
        <IconText>
          {' '}
          <FormattedMessage id='nav.home' />{' '}
        </IconText>
      </Fragment>
    );

  const educatorActiveComponent =
    location.pathname === '/all/educators' ? (
      <Fragment>
        <IconImg src={EducatorActiveIcon} alt='educator-icon' />
        <IconText active>
          {' '}
          <FormattedMessage id='nav.educators' />{' '}
        </IconText>
      </Fragment>
    ) : (
      <Fragment>
        <IconImg src={EducatorIcon} alt='educator-icon' />
        <IconText>
          {' '}
          <FormattedMessage id='nav.educators' />{' '}
        </IconText>
      </Fragment>
    );

  const classroomActiveComponent =
    location.pathname === '/all/classrooms' ? (
      <Fragment>
        <IconImg src={ClassroomActiveIcon} alt='classroom-icon' />
        <IconText active>
          {' '}
          <FormattedMessage id='nav.classrooms' />{' '}
        </IconText>
      </Fragment>
    ) : (
      <Fragment>
        <IconImg src={ClassroomIcon} alt='classroom-icon' />
        <IconText>
          {' '}
          <FormattedMessage id='nav.classrooms' />{' '}
        </IconText>
      </Fragment>
    );

  const authCmp = userData ? (
    <Fragment>
      <AuthWrapper>
        <AvatarTooltipWrapper
          ref={anchorRef}
          aria-controls={openDesktop ? 'profile-menu-list-grow' : undefined}
          aria-haspopup='true'
          onClick={() => handleToggle()}
        >
          {userAvatar ? (
            <UserAvatarImg src={getAvatarImageURL(userData._id)} alt='user-avatar' />
          ) : (
            <AuthIcon src={AvatarIcon} alt='intereact-avatar' />
          )}
          <ArrowIcon src={DownArrowIcon} alt='intereact-down-arrow' />
        </AvatarTooltipWrapper>
      </AuthWrapper>
    </Fragment>
  ) : (
    <AuthWrapper>
      <CustomizedButton
        style={{ height: '2rem', width: '7rem' }}
        customButtonClicked={() => {
          onSetLoginModalState();

          if (openDrawer) setOpenDrawer(!openDrawer);
        }}
        shouldDisable={signUpStarted}
      >
        <FormattedMessage id='nav.sign-in' />
      </CustomizedButton>
    </AuthWrapper>
  );

  const logoCmp = (
    <LogoWrapper>
      <LogoImg
        src={IRLogo}
        alt='logo'
        onClick={() => (location.pathname !== '/' ? history.push('/') : null)}
      />
      <H1> InteReact </H1>
    </LogoWrapper>
  );

  const mobileNavCmp = userData ? (
    <MobileMainWrapper show={showNav}>
      <BurgerBlock style={{ marginLeft: '0.5rem' }} userData={userData}>
        <BurgerImg src={BurgerMenu} alt='menu' onClick={toggleDrawer} />
      </BurgerBlock>
      <AuthWrapper>
        <AvatarTooltipWrapper
          ref={mobileAnchorRef}
          aria-controls={openMobile ? 'profile-menu-list-grow-mobile' : undefined}
          aria-haspopup='true'
          onClick={() => handleMobileToggle()}
        >
          {userAvatar ? (
            <UserAvatarImg src={getAvatarImageURL(userData._id)} alt='user-avatar' />
          ) : (
            <AuthIcon src={AvatarIcon} alt='intereact-avatar' />
          )}
        </AvatarTooltipWrapper>
      </AuthWrapper>
    </MobileMainWrapper>
  ) : (
    <MobileMainWrapper show={showNav}>
      {logoCmp}
      <BurgerBlock userData={userData}>
        <BurgerImg src={BurgerMenu} alt='menu' onClick={toggleDrawer} />
      </BurgerBlock>
    </MobileMainWrapper>
  );

  const langMenuListCmp = (
    <MenuList id='lang-menu-list-grow' onKeyDown={handleLangListKeyDown}>
      <CustomizedMenuItem
        disabled={lang === 'en'}
        iconAltText='en'
        menuIcon={English}
        menuLabel='English'
        handleClick={() => closeLangMenuThenSetLanguage('en')}
      />
      <CustomizedMenuItem
        disabled={lang === 'it'}
        iconAltText='it'
        menuIcon={Italian}
        menuLabel='Italiano'
        handleClick={() => closeLangMenuThenSetLanguage('it')}
      />
      {/*<CustomizedMenuItem*/}
      {/*  disabled={lang === 'kr'}*/}
      {/*  iconAltText='kr'*/}
      {/*  menuIcon={Korean}*/}
      {/*  menuLabel='한국어'*/}
      {/*  handleClick={() => closeLangMenuThenSetLanguage('kr')}*/}
      {/*/>*/}
      {/*<CustomizedMenuItem*/}
      {/*  disabled={lang === 'jp'}*/}
      {/*  iconAltText='jp'*/}
      {/*  menuIcon={Japanese}*/}
      {/*  menuLabel='日本語'*/}
      {/*  handleClick={() => closeLangMenuThenSetLanguage('jp')}*/}
      {/*/>*/}
      {/*<CustomizedMenuItem*/}
      {/*  disabled={lang === 'tl'}*/}
      {/*  iconAltText='tl'*/}
      {/*  menuIcon={Filipino}*/}
      {/*  menuLabel='Filipino'*/}
      {/*  handleClick={() => closeLangMenuThenSetLanguage('tl')}*/}
      {/*/>*/}
      {/*<CustomizedMenuItem*/}
      {/*  disabled={lang === 'fr'}*/}
      {/*  iconAltText='fr'*/}
      {/*  menuIcon={French}*/}
      {/*  menuLabel='Français'*/}
      {/*  handleClick={() => closeLangMenuThenSetLanguage('fr')}*/}
      {/*/>*/}
    </MenuList>
  );

  const menuClickDesktop = (e, path = '/') => {
    handleClose(e);
    history.push(path);
  };

  const menuClickMobile = (e, path = '/') => {
    handleMobileClose(e);
    history.push(path);
  };

  return (
    <Fragment>
      <MainWrapper show={showNav}>
        {logoCmp}
        <LinkWrapper>
          <IconLink to='/'>{homeActiveComponent}</IconLink>
          <HorizontalDivider />
          <IconLink to='/all/classrooms'>{classroomActiveComponent}</IconLink>
          <HorizontalDivider />
          <IconLink to='/all/educators'>{educatorActiveComponent}</IconLink>
        </LinkWrapper>
        {authCmp}
      </MainWrapper>
      {mobileNavCmp}
      <LanguageFooter
        style={{ display: showNav === 'true' ? 'flex' : 'none' }}
        lang={lang}
        ref={langAnchorRef}
        openLangMenu={handleLangToggle}
        open={openLang}
      />
      <MobileDrawer
        anchor={userData ? 'left' : 'right'}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
        open={openDrawer}
        show={showNav}
      >
        {userData ? logoCmp : null}
        <LinkWrapper>
          <IconLink to='/'>{homeActiveComponent}</IconLink>
          <IconLink to='/all/classrooms'>{classroomActiveComponent}</IconLink>
          <IconLink to='/all/educators'>{educatorActiveComponent}</IconLink>
          {userData ? null : (
            <CustomizedButton
              style={{
                height: '2.5rem',
                width: 'calc(100% - 2rem)',
                margin: '0.5rem 1rem',
              }}
              customButtonClicked={() => {
                onSetLoginModalState();

                if (openDrawer) setOpenDrawer(false);
              }}
              shouldDisable={signUpStarted}
            >
              <FormattedMessage id='nav.sign-in' />
            </CustomizedButton>
          )}
          <ExpansionPanel style={{ width: '100%', boxShadow: 'none', marginTop: '1rem' }}>
            <ExpansionPanelSummary
              expandIcon={<i className='material-icons'>keyboard_arrow_down</i>}
            >
              <ExpansionSummaryText>
                {' '}
                <FormattedMessage id='nav.site-language' />{' '}
              </ExpansionSummaryText>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>{langMenuListCmp}</ExpansionPanelDetails>
          </ExpansionPanel>
        </LinkWrapper>
      </MobileDrawer>
      <Popper
        handleClose={handleLangClose}
        open={openLang}
        anchorRef={langAnchorRef}
        closeOnQuery='(max-width:768px)'
      >
        {langMenuListCmp}
      </Popper>
      <Popper anchorRef={anchorRef} open={openDesktop} handleClose={handleClose}>
        <MenuList id='profile-menu-list-grow' onKeyDown={handleListKeyDown}>
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.profile' />}
            menuIcon={ProfileMenuIcon}
            menuLabel={<FormattedMessage id='nav.profile' />}
            handleClick={(e) => menuClickDesktop(e, '/user/me/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.edit-profile' />}
            menuIcon={ProfileEditIcon}
            menuLabel={<FormattedMessage id='nav.edit-profile' />}
            handleClick={(e) => menuClickDesktop(e, '/user/me/edit/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.my-classrooms' />}
            menuIcon={MyClassroomsIcon}
            menuLabel={<FormattedMessage id='nav.my-classrooms' />}
            handleClick={(e) => menuClickDesktop(e, '/user/me/classrooms/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='profile.nav-create-classroom' />}
            menuIcon={CreateClassroomMenu}
            menuLabel={<FormattedMessage id='profile.nav-create-classroom' />}
            handleClick={(e) => menuClickDesktop(e, '/create/classroom/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.settings' />}
            menuIcon={SettingsMenuIcon}
            menuLabel={<FormattedMessage id='nav.settings' />}
            handleClick={(e) => menuClickDesktop(e, '/user/me/settings/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.logout' />}
            menuIcon={LogoutMenuIcon}
            menuLabel={<FormattedMessage id='nav.logout' />}
            handleClick={onLogout}
          />
        </MenuList>
      </Popper>
      <Popper
        anchorRef={mobileAnchorRef}
        open={openMobile}
        handleClose={handleMobileClose}
      >
        <MenuList id='profile-menu-list-grow-mobile' onKeyDown={handleMobileListKeyDown}>
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.profile' />}
            menuIcon={ProfileMenuIcon}
            menuLabel={<FormattedMessage id='nav.profile' />}
            handleClick={(e) => menuClickMobile(e, '/user/me/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.edit-profile' />}
            menuIcon={ProfileEditIcon}
            menuLabel={<FormattedMessage id='nav.edit-profile' />}
            handleClick={(e) => menuClickMobile(e, '/user/me/edit/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.my-classrooms' />}
            menuIcon={MyClassroomsIcon}
            menuLabel={<FormattedMessage id='nav.my-classrooms' />}
            handleClick={(e) => menuClickMobile(e, '/user/me/classrooms/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='profile.nav-create-classroom' />}
            menuIcon={CreateClassroomMenu}
            menuLabel={<FormattedMessage id='profile.nav-create-classroom' />}
            handleClick={(e) => menuClickMobile(e, '/create/classroom/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.settings' />}
            menuIcon={SettingsMenuIcon}
            menuLabel={<FormattedMessage id='nav.settings' />}
            handleClick={(e) => menuClickMobile(e, '/user/me/settings/')}
          />
          <CustomizedMenuItem
            iconAltText={<FormattedMessage id='nav.logout' />}
            menuIcon={LogoutMenuIcon}
            menuLabel={<FormattedMessage id='nav.logout' />}
            handleClick={onLogout}
          />
        </MenuList>
      </Popper>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='info'>
          {signUpStarted ? (
            <FormattedMessage id='signup.modal-signing' />
          ) : (
            <FormattedMessage id='signin.modal-signing' />
          )}
        </Alert>
      </Snackbar>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  lang: state.locale.langLocale,
  signUpStarted: state.user.signUpStarted,
  signUpError: state.user.signUpError,
  justSignedUp: state.user.justSignedUp,
  signInStarted: state.user.signInStarted,
  signInError: state.user.signInError,
  userData: state.user.userData,
  userAvatar: state.user.userAvatar,
});

const mapDispatchToProps = (dispatch) => ({
  onSetLanguage: (lang) => dispatch(setLanguage(lang)),
  onSetLoginModalState: () => dispatch({ type: actionTypes.SET_LOGIN_MODAL_STATE }),
  onUnsetLoginModalState: () => dispatch({ type: actionTypes.UNSET_LOGIN_MODAL_STATE }),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Index));
